import { render } from "./UnitRegistrationList.vue?vue&type=template&id=141f70a5&scoped=true"
import script from "./UnitRegistrationList.vue?vue&type=script&lang=js"
export * from "./UnitRegistrationList.vue?vue&type=script&lang=js"

import "./UnitRegistrationList.vue?vue&type=style&index=0&id=141f70a5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141f70a5"]])

export default __exports__